export const PATIENT_ORGANIZATION_POST_ATTEMPT = "PATIENT_ORGANIZATION_POST_ATTEMPT";
export const patientOrganizationPostAttempt = (payload) => ({
  type: PATIENT_ORGANIZATION_POST_ATTEMPT,
  payload,
});
